export const PaginationConfig = Object.freeze({
    pageSize: 10,
});
